<template>
  <v-expansion-panel v-model="panel" expand>
    <!-- stats chat -->
    <v-expansion-panel-content>
      <template v-slot:header>
        <div>{{$t('chatRealTime')}}</div>
      </template>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 offset-sm6
            class="text-xs-right"
          >
            <v-btn
              color="primary"
              :loading="loadingExportData"
              :disabled="loadingExportData"
              flat
              @click="download()"
            >
              {{ $t('exportInCsv') }}
              <v-icon color="primary" right>file_download</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <!-- Nombre total de chats -->
          <v-flex xs12 sm6 md4>
            <v-card>
              <v-card-text v-if="loading" class="text-xs-center pt-3">
                <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
              </v-card-text>
              <v-container v-else>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div>
                      <div class="subheading text-xs-center">{{ $tc('chats', 2, { count: '' }) | cap }}</div>
                    </div>
                  </v-flex>
                  <v-flex xs12 class="primary--text display-1 text-xs-center">
                    {{ chatsOK }}
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
          <!-- Nombre de messages échangés -->
          <v-flex xs12 sm6 md4>
            <v-card>
              <v-card-text v-if="loading" class="text-xs-center pt-3">
                <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
              </v-card-text>
              <v-container v-else>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div>
                      <div class="subheading text-xs-center">{{ $tc('messages', 2, { count: '' }) | cap }}</div>
                    </div>
                  </v-flex>
                  <v-flex xs12 class="primary--text display-1 text-xs-center">
                    {{ nbMessages }}
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
          <!-- Durée totale des chats -->
          <v-flex xs12 sm6 md4>
            <v-card>
              <v-card-text v-if="loading" class="text-xs-center pt-3">
                <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
              </v-card-text>
              <v-container v-else>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div>
                      <div class="subheading text-xs-center">{{ $t('totalDurationOfChats') | cap }}</div>
                    </div>
                  </v-flex>
                  <v-flex xs12 class="primary--text display-1 text-xs-center">
                    {{ totalDurationFormatted }}
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
          <!-- Durée moyenne des chats -->
          <v-flex xs12 sm6 md4>
            <v-card>
              <v-card-text v-if="loading" class="text-xs-center pt-3">
                <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
              </v-card-text>
              <v-container v-else>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div>
                      <div class="subheading text-xs-center">{{ $t('averageDurationOfOneChat') | cap }}</div>
                    </div>
                  </v-flex>
                  <v-flex xs12 class="primary--text display-1 text-xs-center">
                    {{ averageDurationFormatted }}
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
          <!-- Graphiques jauges Chats -->
          <v-flex xs12 sm6 md4>
            <v-card class="mb-3" :height="heightOfJauge">
              <v-card-text v-if="loading" class="text-xs-center pt-5">
                <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
              </v-card-text>
              <highcharts v-else :options="chatsMissed"></highcharts>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-card class="mb-3" :height="heightOfJauge">
              <v-card-text v-if="loading" class="text-xs-center pt-5">
                <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
              </v-card-text>
              <highcharts v-else :options="chatsByAgentFilter"></highcharts>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-card class="mb-3" :height="heightOfJauge">
              <v-card-text v-if="loading" class="text-xs-center pt-5">
                <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
              </v-card-text>
              <highcharts v-else :options="chatsAverageResponse"></highcharts>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-card class="mb-3" :height="heightOfJauge">
              <v-card-text v-if="loading" class="text-xs-center pt-5">
                <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
              </v-card-text>
              <highcharts v-else :options="chatsFirstResponse"></highcharts>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-card class="mb-3" :height="heightOfJauge">
              <v-card-text v-if="loading" class="text-xs-center pt-5">
                <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
              </v-card-text>
              <highcharts v-else :options="chatsCloseTime"></highcharts>
            </v-card>
          </v-flex>
        </v-layout>

        <!-- Bouton affcihe/cache les historiques des chats visible uniquement pour les start, pro, entreprise -->
        <span>
          <v-btn flat @click="getChats()" color="accent" v-if="histoready">
            {{ $t('hideChat') }}
            <v-icon  right>visibility_off</v-icon>
          </v-btn>
          <v-btn flat @click="getChats()" color="accent" v-else>
            {{ $t('showChat') }}
            <v-icon right>visibility</v-icon>
          </v-btn>
        </span>

        <!-- Historique des chats -->
        <wz-histo-chats
          :params="params"
          :numChatsTotal="String(chatsOK)"
          v-if="histoready"
        ></wz-histo-chats>
      </v-container>
    </v-expansion-panel-content>

    <v-expansion-panel-content>
      <!-- stats messaging -->
      <template v-slot:header>
        <div>Messaging</div>
      </template>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <!-- Nombre total de chats -->
          <!--
          <v-flex xs12 sm6 md4>
            <v-card>
              <v-card-text v-if="loading" class="text-xs-center pt-3">
                <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
              </v-card-text>
              <v-container v-else>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div>
                      <div class="subheading text-xs-center">{{ $tc('chats', 2, { count: '' }) | cap }}</div>
                    </div>
                  </v-flex>
                  <v-flex xs12 class="primary--text display-1 text-xs-center">
                    {{ chatsOKMessaging }}
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
          -->
          <!-- Nombre total de messsage -->
          <!--
          <v-flex xs12 sm6 md4>
            <v-card>
              <v-card-text v-if="loading" class="text-xs-center pt-3">
                <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
              </v-card-text>
              <v-container v-else>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div>
                      <div class="subheading text-xs-center">{{ $tc('messages', 2, { count: '' }) | cap }}</div>
                    </div>
                  </v-flex>
                  <v-flex xs12 class="primary--text display-1 text-xs-center">
                    {{ nbMessagesMessaging }}
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
          -->
        </v-layout>
      </v-container>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import json2csv from 'json2csv'
import 'moment-duration-format'
import { mapGetters, mapState } from 'vuex'

export default {
  data () {
    return {
      loading: false,
      loadingExportData: false,
      loadingMessaging: false,
      chatsOKMessaging: 0,
      nbMessagesMessaging: 0,
      queryCounterMessaging: 0,
      queryCounter: 0,
      chatsOK: 0,
      chatsKO: 0,
      totalChats: 0,
      chatsPostInvit: 0,
      chatsTotalDuration: 0,
      chatsAverageDuration: 0,
      nbMessages: 0,
      chatsAverageResponseValue: 0,
      chatsFirstResponseValue: 0,
      chatsCloseTimeValue: 0,
      histoready: false,
      panel: [true, false],

      // options générales pour les jauges
      optionsJauge: {
        chart: {
          type: 'solidgauge',
          height: 180
        },
        title: {
          style: {
            fontSize: '20px',
            fontFamily: '"Inconsolata", sans-serif'
          }
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        },
        pane: {
          size: '220',
          startAngle: -90,
          endAngle: 90,
          center: ['50%', '95%'],
          background: {
            backgroundColor: '#ddd',
            outerRadius: '100%',
            innerRadius: '90%',
            shape: 'arc',
            borderColor: 'transparent'
          }
        },
        tooltip: {
          enabled: false
        },
        yAxis: {
          min: 0,
          lineWidth: 0,
          minorTickInterval: null,
          tickAmount: 2,
          title: {
            text: ''
          }
        },
        plotOptions: {
          solidgauge: {
            innerRadius: '90%',
            dataLabels: {
              y: 5,
              borderWidth: 0,
              useHTML: true
            }
          }
        },
        series: [{
          data: [0]
        }]
      },
      // options pour chacun des graphiques jauges
      chatsMissed: {
        title: {
          text: _.upperFirst(this.$tc('chatsMissed', 2, {count: ''}))
        },
        yAxis: {
          stops: [[0, '#009688']], // teal
          max: 100
        },
        series: [{
          dataLabels: {
            format: `<div style="text-align:center;font-size:32px;color:` + this.$vuetify.theme.primary + `;">{y:.1f} %</span></div>`
          }
        }]
      },
      chatsByAgentFilter: {
        title: {
          text: this.$t('chatsByAgentFilter')
        },
        yAxis: {
          stops: [[0, '#607D8B']], // blue-grey
          max: 100
        },
        series: [{
          dataLabels: {
            format: `<div style="text-align:center;font-size:32px;color:` + this.$vuetify.theme.primary + `;">{y:.1f} %</span></div>`
          }
        }]
      },
      chatsAverageResponse: {
        yAxis: {
          stops: [[0, '#E91E63']], // pink
          max: 120
        },
        title: {
          text: _.upperFirst(this.$t('chatsAverageResponse'))
        },
        series: [{
          dataLabels: {
            format: `<div style="text-align:center;font-size:32px;color:` + this.$vuetify.theme.primary + `;">{y:.0f} sec.</span></div>`
          }
        }]
      },
      chatsFirstResponse: {
        yAxis: {
          stops: [[0, '#E91E63']], // pink
          max: 120
        },
        title: {
          text: _.upperFirst(this.$t('chatsFirstResponse'))
        },
        series: [{
          dataLabels: {
            format: `<div style="text-align:center;font-size:32px;color:` + this.$vuetify.theme.primary + `;">{y:.0f} sec.</span></div>`
          }
        }]
      },
      chatsCloseTime: {
        yAxis: {
          stops: [[0, '#E91E63']], // pink
          max: 120
        },
        title: {
          text: _.upperFirst(this.$t('chatsCloseTime'))
        },
        series: [{
          dataLabels: {
            format: `<div style="text-align:center;font-size:32px;color:` + this.$vuetify.theme.primary + `;">{y:.0f} sec.</span></div>`
          }
        }]
      }
    }
  },

  created () {
    // initialisation des options liées aux graphiques
    this.chatsMissed = _.merge(this.chatsMissed, this.optionsJauge)
    this.chatsByAgentFilter = _.merge(this.chatsByAgentFilter, this.optionsJauge)
    this.chatsAverageResponse = _.merge(this.chatsAverageResponse, this.optionsJauge)
    this.chatsFirstResponse = _.merge(this.chatsFirstResponse, this.optionsJauge)
    this.chatsCloseTime = _.merge(this.chatsCloseTime, this.optionsJauge)
    this.getAll()
  },

  methods: {
    /**
     * lance toutes les requêtes
     */
    getAll () {
      // affichage des loader
      this.loading = true
      this.queryCounter++
      Promise.all([
        this.getChatsMissed(),
        this.getChatsByAgentFilter(),
        this.getChatsAverageResponse(),
        this.getChatsFirstResponse(),
        this.getChatsCloseTime(),
        this.getChatsDuration(),
        this.getNbMessages()
      ])
      .then(() => {
        if (this.queryCounter === 1) {
          this.loading = false
          // execute les requetes messaging
          // this.getAllMessaging()
        }
        this.queryCounter--
      })
    },
    /**
     * lance toutes les requêtes Messaging
     */
    getAllMessaging () {
      // affichage des loader
      this.loadingMessaging = true
      this.queryCounterMessaging++
      Promise.all([
        this.getNbMessagesMessaging()
      ])
      .then(() => {
        if (this.queryCounterMessaging === 1) {
          this.loadingMessaging = false
          console.log('chargement messaging terminé')
        }
        this.queryCounterMessaging--
      })
    },
    /**
     * Récupère le nombre de chats ainsi que le nombre de chats manqués
     */
    getChatsMissed () {
      return new Promise((resolve, reject) => {
        this.axios.get('get/chats_missed.php?' + this.params)
        .then(response => {
          this.chatsOK = response.data.chatsOK
          this.chatsKO = response.data.chatsKO
          // calcul du ratio de chats manqués
          this.totalChats = this.chatsKO + this.chatsOK
          let ratio = (this.chatsKO / this.totalChats) * 100
          // mise à jour du graphique avec les données récupérées et calculées
          this.chatsMissed.series[0].data[0] = ratio
          this.chatsMissed.yAxis.title.text = this.chatsKO + ' chats'
          resolve()
        })
        .catch((e) => { reject(e) })
      })
    },
    /**
     * Récupère le nombre de chats initiés par agent / ciblage
     */
    getChatsByAgentFilter () {
      return new Promise((resolve, reject) => {
        this.axios.get('get/chats_by_agent_filter.php?' + this.params)
        .then(response => {
          this.chatsPostInvit = response.data.chatsPostInvit
          this.chatsTot = response.data.chatsOK
          // calcul du ratio de chats initiés par agent / ciblage
          let ratio = (this.chatsPostInvit / this.chatsTot) * 100
          // mise à jour du graphique avec les données récupérées et calculées
          this.chatsByAgentFilter.series[0].data[0] = ratio
          this.chatsByAgentFilter.yAxis.title.text = this.chatsPostInvit + ' chats'
          resolve()
        })
        .catch((e) => { reject(e) })
      })
    },
    /**
     * Récupère le temps de réponse moyen
     */
    getChatsAverageResponse () {
      return new Promise((resolve, reject) => {
        this.axios.get('get/chats_average_response.php?' + this.params)
        .then(response => {
          // mise à jour du graphique avec les données récupérées
          this.chatsAverageResponse.series[0].data[0] = response.data.tpsReponse
          this.chatsAverageResponseValue = response.data.tpsReponse
          resolve()
        })
        .catch((e) => { reject(e) })
      })
    },
    /**
     * Récupère le temps de 1ere réponse
     */
    getChatsFirstResponse () {
      return new Promise((resolve, reject) => {
        this.axios.get('get/chats_first_response.php?' + this.params)
        .then(response => {
          // mise à jour du graphique avec les données récupérées
          this.chatsFirstResponse.series[0].data[0] = response.data.tpsReponse
          this.chatsFirstResponseValue = response.data.tpsReponse
          resolve()
        })
        .catch((e) => { reject(e) })
      })
    },
    /**
     * Récupère le temps de cloture
     */
    getChatsCloseTime () {
      return new Promise((resolve, reject) => {
        this.axios.get('get/chats_close_time.php?' + this.params)
        .then(response => {
          // mise à jour du graphique avec les données récupérées
          this.chatsCloseTime.series[0].data[0] = response.data.tempscloture
          this.chatsCloseTimeValue = response.data.tempscloture
          resolve()
        })
        .catch((e) => { reject(e) })
      })
    },
    /**
     * Récupère les durées des chats
     */
    getChatsDuration () {
      return new Promise((resolve, reject) => {
        this.axios.get('get/chats_duration.php?' + this.params)
        .then(response => {
          // mise à jour du graphique avec les données récupérées
          this.chatsTotalDuration = response.data.dureeTotale
          this.chatsAverageDuration = response.data.dureeMoyenne
          resolve()
        })
        .catch((e) => { reject(e) })
      })
    },
    /**
     * Récupère le nombre de messages échangés
     */
    getNbMessages () {
      return new Promise((resolve, reject) => {
        this.axios.get('get/agents_nb_messages.php?' + this.params)
        .then(response => {
          // mise à jour des données récupérées
          this.nbMessages = response.data.nbBulles
          resolve()
        })
        .catch((e) => { reject(e) })
      })
    },
    /**
     * Récupère le nombre de messages messaging échangés
     */
    getNbMessagesMessaging () {
      return new Promise((resolve, reject) => {
        this.axios.get('get/agents_nb_messages_messaging.php?' + this.params)
        .then(response => {
          // mise à jour des données récupérées
          this.nbMessagesMessaging = response.data.nbBulles
          resolve()
        })
        .catch((e) => { reject(e) })
      })
    },

    download () {
      this.loadingExportData = true
      let csv = null
      const fields = [
        'chats',
        'messages',
        'totalDurationOfChats',
        'averageDurationOfOneChat',
        'chatsMissed',
        'chatsByAgentFilter',
        'chatsAverageResponse',
        'chatsFirstResponse',
        'chatsCloseTime'
      ]
      const fieldNames = [
        this.$tc('chats', 2, { count: '' }),
        this.$tc('messages', 2, { count: '' }),
        this.$t('totalDurationOfChats'),
        this.$t('averageDurationOfOneChat'),
        this.$tc('chatsMissed', 2, {count: ''}),
        this.$t('chatsByAgentFilter'),
        this.$t('chatsAverageResponse'),
        this.$t('chatsFirstResponse'),
        this.$t('chatsCloseTime')
      ]
      const data = {
        chats: this.chatsOK,
        messages: this.nbMessages,
        totalDurationOfChats: this.chatsTotalDuration,
        averageDurationOfOneChat: this.chatsAverageDuration,
        chatsMissed: this.chatsKO,
        chatsByAgentFilter: this.chatsPostInvit,
        chatsAverageResponse: this.chatsAverageResponseValue,
        chatsFirstResponse: this.chatsFirstResponseValue,
        chatsCloseTime: this.chatsCloseTimeValue
      }
      try {
        csv = json2csv({ data, fields, del: ';', fieldNames })
      } catch (err) {
        this.loadingExportData = false
        return
      }

      // téléchargement du fichier csv
      var hiddenElement = document.createElement('a')
      hiddenElement.href = 'data:attachment/text,' + encodeURI(csv)
      hiddenElement.target = '_blank'
      hiddenElement.download = 'chats.csv'
      document.body.appendChild(hiddenElement)
      hiddenElement.click()
      this.loadingExportData = false
    },
    getChats () {
      if (this.histoready) {
        this.histoready = false
      } else {
        this.histoready = true
      }
    }
  },

  computed: {
    ...mapGetters('_Stats', ['params']),
    ...mapState('_User', ['entLevel']),
    heightOfJauge () {
      return this.optionsJauge.chart.height + 'px'
    },
    totalDurationFormatted () {
      return moment.duration(this.chatsTotalDuration, 'seconds').format('h[h] m[m] s[s]')
    },
    averageDurationFormatted () {
      return moment.duration(this.chatsAverageDuration, 'seconds').format('h[h] m[m] s[s]')
    }
  },

  watch: {
    params (v) {
      this.getAll()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/stats/Chats.vue